import { EditElementOutDto, EditElementInDto } from '../../../types/element.dto'

export const EDIT_ELEMENT = 'EDIT_ELEMENT'
export const EDIT_ELEMENT_SUCCESS = 'EDIT_ELEMENT_SUCCESS'
export const EDIT_ELEMENT_ERROR = 'EDIT_ELEMENT_ERROR'
export const RESET_EDIT_ELEMENT = 'RESET_EDIT_ELEMENT'

export interface EditElement<T> {
  type: typeof EDIT_ELEMENT
  payload: EditElementOutDto<T>
}

export interface EditElementSuccess<T> {
  type: typeof EDIT_ELEMENT_SUCCESS
  payload: EditElementInDto<T>
}

export interface EditElementError {
  type: typeof EDIT_ELEMENT_ERROR
  payload: string | boolean
}

export interface ResetEditElement {
  type: typeof RESET_EDIT_ELEMENT
  payload: null
}

export interface State<T> {
  data: EditElementInDto<T> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

// Define una función que acepte un parámetro T y devuelva un initialState con ese tipo T
const createInitialState = <T>(): State<T> => {
  return {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  };
};

// Ahora puedes usar esta función para inicializar el estado con el tipo T que necesites
export const initialState = createInitialState<any>();

export type Actions<T> = EditElement<T> | EditElementSuccess<T> | EditElementError | ResetEditElement
